import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { z } from 'zod';

import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { CustomerProvidedVariablesContainer } from '~/packages/portfolio/ui/customerProvidedVariables/CustomerProvidedVariablesContainer';
import { PortfolioTemplate } from '~/packages/portfolio/ui/shared/PortfolioTemplate';

// Types
const RouteParamsStruct = z.object({
  creditFacility: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const [queryParams] = useSearchParams();
  const { creditFacility: creditFacilityId } = RouteParamsStruct.parse(
    Object.fromEntries(queryParams),
  );
  const cleanedCreditFacilityId = creditFacilityId.replace(/['"]/g, '');
  const creditFacility = useCreditFacilityOrThrow(cleanedCreditFacilityId);
  return (
    <PortfolioTemplate
      creditFacilityId={creditFacility.id}
      creditFacilityName={creditFacility.name}
      selectedTab="customerProvidedVariables"
    >
      <CustomerProvidedVariablesContainer
        creditFacilityId={creditFacility.id}
      />
    </PortfolioTemplate>
  );
};

// Exports
export const Route = () => {
  const flags = useFeatureFlags();
  if (flags.productsCustomerProvidedVariablesPermissions !== 'allow') {
    return <Navigate to="/portfolio/overview/facilities" />;
  }

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/portfolio/overview/facilities" />;
      }}
    >
      <Box width="100%" padding="2.5rem">
        <RouteBase />
      </Box>
    </RouteErrorBoundary>
  );
};
